// extracted by mini-css-extract-plugin
export default {"itemFrame":"aR7oRn","gray":"gulURU","normal":"l8ydkV","bright":"CgtCOC","itemImage":"SJEwCv","noImage":"IZbVCY"};